import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import * as ticketsActions from 'redux/modules/tickets';
import { initializeWithKey } from 'redux-form';
import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { isLoaded as areTicketsLoaded, load as loadTickets } from 'redux/modules/tickets';
var _ = require('underscore');
import { TicketList } from 'components';
import { ErrorAlert } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    //promises.push(dispatch(loadGroups(params)));
    promises.push(dispatch(loadTickets(params)));
    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    tickets: state.tickets.data,
    ticket_editing: state.tickets.ticket_editing,
    error: state.tickets.error,
    loading: state.tickets.loading,
    user: state.auth.user,
  }),
  { ...ticketsActions, initializeWithKey })

export default class Tickets extends Component {

  componentDidMount() {
    //this.props.cancelEdit();
  }

  /*componentWillUnmount(){
  	this.props.clearProducts();
  }*/

  render() {

    const handleEdit = (product) => {
      const { editStart } = this.props; // eslint-disable-line no-shadow
      return () => editStart(product.id);
    };

    const handleDelete = (id) => {
      const { deleteProduct } = this.props; // eslint-disable-line no-shadow
      return () => deleteProduct(parseInt(id), this.props.params);
    };

    const handleLoad = (page) => {
      const { load } = this.props; // eslint-disable-line no-shadow
      return () => load(this.props.params);
    };

    const {
      tickets, params, loading, user, error, createMessage,t
    } = this.props;

    let refreshClassName = 'fa fa-refresh';
    if (loading) {
      refreshClassName = 'fa fa-refresh fa-spin';
    }
    const styles = require('./Tickets.scss');


    return (
      <div className={styles.products + ' container'}>
        <div>
          <h1>Tickets&nbsp;
	          <button className={styles.refreshBtn + ' btn btn-success'} onClick={handleLoad()}>
              <i className={refreshClassName} /> {' '}
            </button>
          </h1>
        </div>

        <Helmet title="Tickets" />

        {error != false &&
          <ErrorAlert buttonText={t("dashboardView.reload_page")} callback={handleLoad()} />
        }


        {tickets.length > 0 &&
          <Row>
            <Col md={12} >
              <TicketList tickets={tickets} user={user} params={params} createMessage={createMessage} />
            </Col>
          </Row>
        }

      </div>
    );
  }
}